import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUploadAlt } from '@fortawesome/pro-light-svg-icons/faCloudUploadAlt';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight';
import { faServer } from '@fortawesome/pro-light-svg-icons/faServer';
import { faSignIn } from '@fortawesome/pro-light-svg-icons/faSignIn';

import Styles from '../styles.module.scss';

const BrokersSolutionSection = () => (
  <div className={Styles['brokers-solution-section']}>
    <div className={Styles.section}>
      <h2>Choose The Solution That Works For You</h2>
      <p>
        Affordable plans for every level, from small
        individual wealth advisors to institutional fund managers
      </p>
      <div className={Styles['flex-wrapper']}>
        <div className={Styles.column}>
          <h5>
            <FontAwesomeIcon icon={faCloudUploadAlt} />
            Real-time API
          </h5>
          <p>Take the programmatic approach to conducting research and managing knowledge</p>
          <Link to="/products/api/financial-news/pricing-api/commercial">
            Browse Tiers
            <FontAwesomeIcon icon={faAngleRight} />
          </Link>
        </div>
        <div className={Styles.column}>
          <h5>
            <FontAwesomeIcon icon={faServer} />
            Historical Data Sets
          </h5>
          <p>Backtest trading models and support your analysis with detailed historical data</p>
          <Link to="/products/api/financial-news/pricing-historical">
            Choose Data
            <FontAwesomeIcon icon={faAngleRight} />
          </Link>
        </div>
        <div className={Styles.column}>
          <h5>
            <FontAwesomeIcon icon={faSignIn} />
            Single Sign-on (SSO)
          </h5>
          <p>Is available to provide seamless to enterprises and institutions</p>
          <div>
            <label>Coming Soon</label>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default BrokersSolutionSection;
